import DashboardsCreate from './DashboardsCreate';

export default DashboardsCreate;